import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { resourcePath } from '../../../utils/helpers';
import { Heading1, Heading3 } from '../../design-system/headings';
import './message.scss';

export const Message = observer(({ ui }) => {
    const { t } = useTranslation('assessment');

    return (
        <div className="assessment-presentation">
            <div className="question">
                <Heading1 mb={8}>{t(ui.title)} </Heading1>
                <p>{t(ui.description)} </p>
                <div className="chat-message">
                    <div className="img">
                        <img
                            src={resourcePath(ui.messenger_image)}
                            alt="illustration"
                        />
                    </div>
                    <div className="message">
                        <div className="top">
                            <div className="name">{t(ui.messenger_name)}</div>
                            <div className="time">{ui.messenger_time}</div>
                        </div>
                        <div className="text">{t(ui.messenger_text)}</div>
                    </div>
                </div>
                <br />
                <Heading3 lighter>{t(ui.pretitle)} </Heading3>
            </div>
        </div>
    );
});
